<template>
  <div id="about__medio" class="fade-in-up">
    <div id="header">
      <div class="img__header">
        <div class="bg__escuro"></div>
        <div class="bg__title">
          <b-container fluid="lg">
            <h2 class="text-title">Ensino Médio</h2>
          </b-container>
        </div>
      </div>
    </div>

    <BreadSistema class="bread__about" />

    <b-container fluid="lg">
      <div class="clearfix">
        <div class="float-left box-image">
          <div class="text-center">
            <img src="../../assets/images/image-pages/educacao-ensino-medio-cpv.png" alt="">
          </div>
        </div>
        <div class="float-right box-text text-left">
          <div class="content-text">
            <h5 class="text-uppercase font-weight-bolder">Proposta Pedagógica</h5>
            <p class="font-weight-light lead">O grande desafio do vestibular exige um preparo sólido e consistente. A
              formação geral adquirida ao longo do Ensino Fundamental é retomada, agora de maneira mais direcionada.</p>
            <p>Ao longo do curso, o aluno aprofundará seu conhecimento sobre todos os temas do programa e identificar a
              maneira como eles são cobrados no ENEM e nos mais concorridos vestibulares.</p>
            <h5 class="text-uppercase font-weight-bolder mt-4">Material didático</h5>
            <p>Para que as escolas parceiras garantam o sucesso de seus alunos nas melhores universidades, oferecemos o
              conteúdo teórico exigido pelo MEC e pelas Bancas mais exigentes distribuídos em dois anos e meio,
              reservando para o segundo semestre do 3º ano uma ampla revisão, focada em exercícios para o ENEM e demais
              vestibulares. Tudo atualizado e dimensionado pela equipe que aprova mais de 80% de seus alunos nos
              principais vestibulares.</p>
            <hr>
            <div class="d-block mx-auto">
              <h5 class="text-center font-weight-bolder text-uppercase">Para mais informações</h5>
              <p class="text text-center">
                Para mais informações sobre esse material, solicite hoje um consultor do Sistema de Ensino CPV.
              </p>
              <div class="d-flex justify-content-center">
                <b-button class="btn__consultor" :to="{ name: 'escolaParceira' }" variant="transparent">
                  <i class="fa-regular fa-messages"></i>
                  <span>Fale com um consultor</span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'ensino-infantil',
  components: { BreadSistema: () => import('../GlobalComponents/bread-sistema.vue') },
};
</script>


<style lang="scss" scoped>
#about__medio {
  background-color: #ffffff;

  #header {
    .img__header {
      background-image: url('https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2019/10/11163757/bg_medio_comprimido.jpg');
      background-repeat: no-repeat;
      background-position: center center;
    }
  }

  h5 {
    color: #e98b24;
  }

  p {
    font-size: 16px;
    line-height: 22px;
  }

  .lead {
    font-size: 24px;
    line-height: 32px;
  }

  .btn__consultor {
    display: inline-flex;
    min-width: auto;
    min-height: auto;

    margin: 0px auto 0;
    padding: 8px 16px;

    gap: 6px;

    background-color: #e98b24;
    border: 1px solid #e98b24;
    border-radius: 5px;

    display: flex;
    align-items: center;

    font-size: 14px;
    line-height: 20px;

    color: #fdf3e9;

    .icon {
      width: 18px;
      height: 18px;

      display: flex;
      align-items: center;

      i {
        font-size: 14px;
        line-height: 20px;
      }
    }

    &:hover {
      background-color: #d27d20;
      transition: all 0.3s ease-in-out;
      border: 1px solid #d27d20;
    }
  }
}

@media screen and (min-width: 1200px) {
  .box-image {
    width: 35%;
    margin-top: 0px;
    max-height: 917px;

    img {
      display: block;
      margin-top: 50px;
      margin-left: -175px;
      // margin-right: 150px;
      height: auto;
      object-fit: cover;

    }
  }

  .box-text {
    width: 65%;
    display: block;
    margin: 30px auto;

    .content-text {
      padding-left: 32px;
      padding-right: 32px;
    }
  }
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
  .box-image {
    width: 100%;
    margin-top: -16px;
    height: auto;
    margin-bottom: 30px;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-width: 100%;
      height: auto;
    }
  }

  .box-text {
    width: 100%;

    .content-text {
      padding-left: px;
      padding-right: 16px;
      margin-bottom: 20px;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 992px) {
  .box-image {
    width: 100%;
    margin-top: -16px;
    height: auto;
    margin-bottom: 30px;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-width: 100%;
      height: auto;
    }
  }

  .box-text {
    width: 100%;

    .content-text {
      padding-left: px;
      padding-right: 16px;
      margin-bottom: 20px;
    }
  }
}

@media screen and (min-width: 576px) and (max-width: 768px) {
  .box-image {
    width: 100%;
    margin-top: -16px;
    height: auto;
    margin-bottom: 30px;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-width: 100%;
      height: auto;
    }
  }

  .box-text {
    width: 100%;

    .content-text {
      padding-left: 16px;
      padding-right: 16px;
      margin-bottom: 20px;
    }
  }
}

@media screen and (max-width: 576px) {
  .box-image {
    width: 100%;
    margin-top: -16px;
    height: auto;
    margin-bottom: 30px;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-width: 100%;
      height: auto;
    }
  }

  .box-text {
    width: 100%;

    .content-text {
      padding-left: 16px;
      padding-right: 16px;
      margin-bottom: 20px;
    }
  }
}
</style>
